<template>
  <div class="scenicParkDetail">
    <loading v-if="isLoading"></loading>
    <div v-else>
      <!-- 顶部打开app -->
      <openAppDialog
        ref="openApp"
        :title="openTitle"
        :shareId="shareId"
        :shareType="shareType"
        isShow="true"
        @openApp="openApp()"
      ></openAppDialog>
      <div v-if="!emptyShow">
        <div class="banner_container">
          <van-swipe
            :autoplay="5000"
            :loop="true"
            :show-indicators="true"
            @change="swiperChange('img', $event)"
          >
            <div slot="indicator" class="indicator_box">{{ imgIndex + 1 }} / {{ imgList.length }}</div>
            <van-swipe-item v-for="(item, index) in imgList" :key="index">
              <van-image width="100%"  fit="contain" :src="item.imageUrl"></van-image>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="desc_container">
          <div class="desc_box">
            <div class="desc_left">
              <div class="desc_title">{{ detailData.title }}</div>
              <div class="desc_label_box" v-if="detailData.tagNames">
                <div
                  class="desc_label"
                  v-for="(item, index) in detailData.tagNames.split(',')"
                  :key="index"
                >{{ item }}</div>
              </div>
            </div>
            <div class="desc_right">
              <div class="right_top">
                <div class="right_collect" @click="showApp">
                  <img
                    :src="
                      collectObj.is_collect
                        ? require('../../assets/img/likeAfterIcon.png')
                        : require('../../assets/img/collectBefore_icon.png')
                    "
                    alt
                  />
                  <div
                    :style="{
                      color: collectObj.is_collect ? '#FF504D' : '#262626',
                    }"
                  >
                    {{
                    Number(collectObj.count) >= 10000
                    ? (Number(collectObj.count) / 10000).toFixed(1) + "w"
                    : Number(collectObj.count) >= 1000
                    ? (Number(collectObj.count) / 1000).toFixed(1) + "k"
                    : Number(collectObj.count)
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="desc_bottom">
            <div class="bottom_item">
              <div class="number">{{ Number(detailData.viewingHours) }}</div>
              <div class="text">小时</div>
              <div class="item_line"></div>
            </div>
            <div class="bottom_item_line"></div>
            <div class="bottom_item">
              <div class="number">{{ Number(detailData.mileage) }}</div>
              <div class="text">公里</div>
              <div class="item_line"></div>
            </div>
            <div class="bottom_item_line"></div>
            <div class="bottom_item">
              <div class="number">{{ detailData.routeScheduleVos.length }}</div>
              <div class="text">景点</div>
              <div class="item_line"></div>
            </div>
          </div>
        </div>

        <div class="intro_container">
          <div class="intro_title">出行提醒</div>
          <div
            class="intro_innerText"
            :style="{ marginBottom: '30px' }"
          >{{ detailData.travelRemind }}</div>
          <div class="intro_title">路线概况</div>
          <div class="intro_innerText">{{ detailData.brief }}</div>
          <van-image
            class="intro_map"
            radius="3px"
            width="100%"
            height="150px"
            fit="cover"
            :src="detailData.scheduleImage"
          ></van-image>
        </div>

        <div
          class="pro_box"
          v-if="
            detailData.routeScheduleVos &&
              detailData.routeScheduleVos.length > 0
          "
        >
          <div class="pro_item_start">
            <img class="item_img" src="../../assets/img/current_icon.png" alt />
            <div class="item_text">
              <div class="text_title">起点</div>
              <div class="text_desc">(我的位置)</div>
            </div>
          </div>
          <div class="pro_item" v-for="(item, index) in detailData.routeScheduleVos" :key="index">
            <div class="item_bottom">
              <div class="position_index">{{ index + 1 }}</div>
              <div class="item_bottom_img">
                <div :style="{ width: 66 + 'px' }">
                  <van-image width="66px" height="66px" fit="cover" :src="item.image"></van-image>
                </div>

                <div class="item_bottom_middle">
                  <div class="middle_title">{{ item.targetName }}</div>
                  <div
                    class="middle_distance"
                    v-if="isShowDistance"
                  >距你{{ distance(item.latitude, item.longitude) }}</div>
                  <div class="middle_labels" v-if="item.tags">
                    <div
                      class="middle_label"
                      v-for="(item, index) in item.tags.split(',')"
                      :key="index"
                    >{{ item }}</div>
                  </div>
                </div>
              </div>

              <div class="item_bottom_right">
                <div
                  v-if="item.voiceMan || item.voiceWoman"
                  class="right_item right_first"
                  @click="showApp"
                >
                  <img src="../../assets/img/gray_say.png" alt />
                  <div>讲解</div>
                </div>
                <div v-else class="right_item right_first" :style="{ visibility: 'hidden' }">
                  <img src="../../assets/img/gray_say.png" alt />
                  <div>讲解</div>
                </div>
                <div class="right_item" @click="showApp">
                  <img src="../../assets/img/goHere_icon.png" alt />
                  <div>去这里</div>
                </div>
              </div>
            </div>

            <div class="item_item_top" v-if="item.walkDistance">
              <div class="position_icon">
                <img src="../../assets/img/walk_icon.png" alt />
              </div>
              <div class="item_top_text">
                步行距离{{ Number(item.walkDistance) }}m&nbsp;|&nbsp;约{{
                Number(item.walkTime)
                }}分钟
              </div>
            </div>
          </div>
          <div class="pro_item_start">
            <img class="item_img" src="../../assets/img/current_icon.png" alt />
            <div class="item_text">
              <div class="text_title">终点</div>
              <!-- <div class="text_desc">(我的位置)</div> -->
            </div>
          </div>
        </div>

        <!-- 用户评论 -->
        <div class="comment-box">
          <van-cell title="精彩点评" is-link :value="'全部 ' + CommentNum + ' 条热评'" @click="showApp" />
          <div class="comment-list" v-if="CommentNum !== 0">
            <customListView
              :arraydata="commentList"
              @itemDianZan="showApp"
              @itemClick="showApp"
              @bigPictureLook="showApp"
              @itemReply="showApp"
            ></customListView>
          </div>
          <div class="list-no" v-if="CommentNum === 0">
            <p>来发表第一条评论吧~</p>
          </div>
          <div class="btn">
            <van-button color="#2EBA73" @click="showApp">写点评</van-button>
          </div>
        </div>

        <div>
          <writeComment ref="writeComment" @Fb="showApp" id="modalId"></writeComment>
        </div>

        <div>
          <displayimage ref="displayimage"></displayimage>
        </div>
        <!-- 用户评论 end -->

        <!-- 猜你喜欢 -->
        <div class="recommend_container" v-if="aroundData.length > 0">
          <div class="recommend_title">
            <div class="title_left">猜你喜欢</div>
          </div>
          <div class="best_container">
            <!-- <swiper :options="{slidesPerView: 2.3, spaceBetween: 0,slidesOffsetAfter: 20}" ref="mySwiper"> -->
            <div class="best_item" v-for="(item, index) in aroundData" :key="index">
              <div @click="showApp" v-if="index == 0" :style="{ paddingBottom: '20px' }">
                <div class="item_left">
                  <van-image
                    radius="3px"
                    height="160px"
                    fit="cover"
                    lazy-load
                    :src="item.cover_img"
                  />
                </div>
                <div class="item_right">
                  <div class="title item_title">{{ item.name }}</div>
                  <div class="label_box" v-if="item.tagNames">
                    <div
                      class="label"
                      v-for="(item, index) in item.tagNames.split(',')"
                      :key="index"
                    >{{ item }}</div>
                  </div>
                  <div class="distance">
                    <span class="location">全程28公里</span>
                    <span class="distance" v-if="isShowDistance">
                      &nbsp;&nbsp;|&nbsp;&nbsp;距你{{
                      distance(item.latitude, item.longitude)
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- </swiper> -->
          </div>
        </div>
        <!-- 猜你喜欢 end -->
      </div>
      <empty
        v-else
        ref="emptyView"
        :toastTitle="toastTitle"
        :emptyShow="emptyShow"
        :style="{ top: emptyTop }"
      ></empty>
    </div>
  </div>
</template>

<script>
import openAppDialog from "@/components/openAppTopDialog.vue";
import Loading from "@/components/loading";
import writeComment from "@/components/writeComment.vue";
import customListView from "@/components/customListViewComment.vue";
import displayimage from "@/components/displayImage.vue";
import empty from "@/components/empty.vue";
// eslint-disable-next-line no-irregular-whitespace
import Vue from "vue";
// eslint-disable-next-line no-irregular-whitespace
import { Lazyload } from "vant";

Vue.use(Lazyload);

export default {
  name: "line_list",
  data() {
    return {
      openTitle: "打开天府绿道APP<br/>欣赏更多精彩线路",
      shareId: this.$route.query.id,
      shareType: "",
      toastTitle: "糟糕,数据找不到了",
      emptyShow: false,
      emptyTop: "46px",
      isPageError: false,
      isLoading: true,
      // 图片数组
      imgList: [],
      CommentNum: 0, // 评论条数
      commentList: [],
      scenicId: "",
      imgIndex: 0,
      detailData: {},
      //附近推荐
      aroundTabArray: [],
      aroundData: [],
      allATbArr: [],
      aroundTabActive: 0,
      // 收藏数据对象
      collectObj: {
        count: 0,
      },
      // 当前选择的audio对象 用于音频切换传参
      currentAudio: {},
      // 全局音频组件所在vue实例对象 (App.vue)
      App: this.$root.$children[0],
    };
  },
  components: {
    // LeftImg,
    Loading,
    // PageError,
    // TabCheckout,
    writeComment,
    customListView,
    displayimage,
    openAppDialog,
    empty,
  },
  watch: {
    $route() {
      // this.$router.go(0);
      this.isLoading = true;
      window.location.reload();
    },
  },
  // beforeRouteUpdate(to, from, next) {
  //   next();
  //   // window.location.reload();
  //   this.$router.go(0)

  // },
  mounted() {
    this.uid = this.$cookie.get("w_uid") || "";
    this.scenicId = this.$route.query.id;
    this.isShowDistance = Boolean(sessionStorage.getItem("isShowDistance"));
    this.getCommentList();
    this.getlineDetail();
    this.getRecommend();
    this.getCollectNum();
  },
  methods: {
    showApp() {
      this.$refs.openApp.showToast();
    },
    openApp() {
      //打开APP,跳转到APP
      //eslint-disable-next-line
      console.log("openApp()");
    },
    /**
     * 去详情
     */
    toDetail(item) {
      this.$router.replace({
        path: "/lineDetails",
        query: {
          id: item.id,
          lat: this.$route.query.lat,
          lng: this.$route.query.lng,
        },
      });
    },

    /**
     * 去导航
     */
    goToLocation(item) {
      window.location.href =
        "http://apis.map.qq.com/tools/poimarker?type=0&marker=coord:" +
        item.latitude +
        "," +
        item.longitude +
        ";title:" +
        "成都市" +
        ";address:" +
        item.address +
        "&key=LJKBZ-2WTRW-JT7RQ-OSONW-ZO6X7-ZMFMG&referer=myapp";
    },

    /**
     * 获取猜你喜欢数据
     */
    getRecommend() {
      let data = new FormData();
      data.append("srcType", "scenic_route");
      data.append("srcId", this.scenicId);
      this.$http
        .post(`/appserver/v1/recommend/ld_detail_recommend`, data)
        .then((res) => {
          if (res.data.ret == 0) {
            this.aroundData = res.data.data;
          } else {
            this.$toast("获取猜你喜欢失败");
          }
        })
        .catch(() => {});
    },

    /**
     * 获取收藏数量/收藏状态
     */
    getCollectNum() {
      this.$http
        .get(
          `/appserver/v1/collect/is/collect?srcType=scenic_route&srcId=${this.scenicId}`
        )
        .then((res) => {
          if (res.data.ret == 0) {
            let resData = res.data.data;
            this.collectObj = resData;
          }
        })
        .catch(() => {});
    },

    /**
     * 提交收藏
     */
    postCollect() {
      // 未登录情况
      if (!this.$cookie.get("w_uid")) {
        this.wxAuth();
        return;
      }
      let data = new FormData();
      data.append("srcType", "scenic_route");
      data.append("srcId", this.scenicId);
      if (this.collectObj.is_collect) {
        this.$http
          .post(`/appserver/v1/collect/cancel`, data)
          .then((res) => {
            if (res.data.ret == 0) {
              this.$toast("取消收藏!");
              this.collectObj.is_collect = 0;
              this.collectObj.count = Number(this.collectObj.count) - 1;
            } else {
              this.$toast("取消收藏失败");
            }
          })
          .catch(() => {});
      } else {
        this.$http
          .post(`/appserver/v1/collect/save`, data)
          .then((res) => {
            if (res.data.ret == 0) {
              this.$toast("收藏成功!");
              this.collectObj.is_collect = 1;
              this.collectObj.count = Number(this.collectObj.count) + 1;
            } else {
              this.$toast("收藏失败");
            }
          })
          .catch(() => {});
      }
    },

    /**
     * 附近推荐 tab切换
     */
    aroundTabCheckout(data) {
      this.aroundTabActive = data.index;
      this.aroundData = this.allATbArr[data.index];
    },

    swiperChange(type, event) {
      this.imgIndex = event;
    },

    /**
     * 控制视频播放/暂停
     */
    videoPlay(event) {
      if (event.target.paused) {
        event.target.play();
      } else {
        event.target.pause();
      }
    },

    /**
     * 播放语音
     */
    palyAudio(item) {
      this.App.audioWoMan = item.voiceWoman == "[]" ? "" : item.voiceWoman;
      this.App.audioMan = item.voiceMan == "[]" ? "" : item.voiceMan;
      this.App.audioTitle = item.targetName;
      this.App.palyAudio();
    },
    /**
     * 获取线路详情数据
     */
    getlineDetail() {
      this.$http
        .get(`/appserver/v1/route/details?id=${this.scenicId}`)
        .then((res) => {
          if (res.data.ret == 0 && res.data.data != null) {
            let resData = res.data.data;
            this.isLoading = false;
            if (resData.galleryVos) {
              this.imgList = resData.galleryVos;
            }
            this.detailData = resData;
          } else {
            this.isLoading = false;
            this.toastTitle = "糟糕,数据找不到了";
            this.emptyShow = true;
          }
        })
        .catch(() => {
          // console.log(e);
          this.isLoading = false;
          this.toastTitle = "网络出错,请稍后再试!";
          this.emptyShow = true;
        });
    },

    /**
     * 跳转至导航页
     */
    toMap(lat, lng, location, address) {
      window.location.href =
        "http://apis.map.qq.com/tools/poimarker?type=0&marker=coord:" +
        lat +
        "," +
        lng +
        ";title:" +
        location +
        ";addr:" +
        address +
        "&key=LJKBZ-2WTRW-JT7RQ-OSONW-ZO6X7-ZMFMG&referer=myapp";
    },

    /**
     * 计算距离你多少距离
     * @params lat lng 景区 景点 经纬度
     */
    distance(lat, lng) {
      if (this.$route.query.lat && this.$route.query.lng) {
        let obj = this.getDistance(
          lat,
          lng,
          this.$route.query.lat,
          this.$route.query.lng
        );
        return obj.distance.toFixed(1) + (obj.type == "km" ? "公里" : "米");
      } else {
        // return { distance: '', text: '' };
        return "0米";
      }
    },
    /**
     * 获取评论
     */
    getCommentList() {
      let fromData = new FormData();
      // console.log(this.scenicId, 'this.grenen')
      fromData.append("cid", this.scenicId);
      fromData.append("type", "scenic_route");
      this.$http.post(`/appserver/v1/comment/list`, fromData).then((data) => {
        let _data = data.data.data;
        if (_data.list.length !== 0) {
          this.commentList = _data.list;
        }
        this.CommentNum = _data.comment_num; // 评论条数
      });
    },

    /**
     * 用户点赞回调
     */
    itemDianZan(item, commId) {
      if (!this.uid) {
        this.wxAuth();
        return;
      }
      // let data = {
      //   comment_id: commId,
      //   number: "1",
      // };
      let fromData = new FormData();
      fromData.append("comment_id", commId);
      fromData.append("number", 1);
      this.$http
        .post(`/appserver/v1/comment/deleteOrUp`, fromData, {
          headers: {
            uid: this.uid,
          },
        })
        .then((data) => {
          if (data.data.ret === 0) {
            item.up++;
            item.is_up = !item.is_up;
          } else {
            this.$toast(data.data.msg);
          }
        });
    },

    /**
     * 回复
     * @params item 回复的评论item commId  回复的commitId
     */
    itemReply(item, commId) {
      this.parentId = commId;
      var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        let windheight = document.documentElement.clientHeight; //为唤起软键盘时当前窗口高度
        document.getElementById("modalId").style.position = "relative";
        window.onresize = function () {
          var docheight = document.documentElement.clientHeight; //唤起软键盘时窗口高度
          document.getElementById("write").style.bottom =
            docheight - windheight + "px";
        };
      }
      if (this.uid) {
        this.$refs.writeComment.showWriteDialog();
      } else {
        this.wxAuth();
      }
    },

    // 用户评论列表
    AllDiscussList() {
      if (this.CommentNum <= 0) {
        return;
      } else {
        this.$router.push({
          path: "/allDiscussList",
          query: {
            cid: this.scenicId,
            type: "scenic_route",
          },
        });
      }
    },
    // 评论详情
    Details(item) {
      this.$router.push({
        path: "/discussDetails",
        query: {
          comment_id: item.comment_id,
          type: "scenic_route",
          from: "web",
        },
      });
    },
    // 图片点击放大
    BigPictureLook(item, index) {
      this.$refs.displayimage.showBigPictureLook(item.image, index);
    },
    // 写评论
    Write() {
      // 确保parentId为空，不是回复操作
      this.parentId = null;
      var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        let windheight = document.documentElement.clientHeight; //为唤起软键盘时当前窗口高度
        document.getElementById("modalId").style.position = "relative";
        window.onresize = function () {
          var docheight = document.documentElement.clientHeight; //唤起软键盘时窗口高度
          document.getElementById("write").style.bottom =
            docheight - windheight + "px";
        };
      }
      if (this.uid) {
        this.$refs.writeComment.showWriteDialog();
      } else {
        this.wxAuth();
      }
    },
    // 发表
    Fb(msg) {
      var message = msg[0];
      var gallerysStr = msg[1];
      let fromData = new FormData();
      fromData.append("content", message);
      fromData.append("cid", this.scenicId);
      fromData.append("ctitle", document.title);
      fromData.append("type", "scenic_route");
      fromData.append("source_type", "h5");
      fromData.append("image", gallerysStr);
      if (this.parentId) {
        fromData.append("parent_id", this.parentId);
      }
      this.$http
        .post(`/appserver/v1/comment/addComment`, fromData, {
          headers: {
            uid: this.uid,
          },
        })
        .then((data) => {
          // console.log(data, 'asdasdasdasd');
          if (data.data.ret == 0) {
            if (this.parentId) {
              this.$toast("回复成功");
            } else {
              this.$toast("发布成功");
            }
            this.getCommentList();
            this.$refs.writeComment.ClosePost();
          } else {
            this.$refs.writeComment.ClosePost();
            if (data.data.msg == "缺少uid请登录") {
              this.wxAuth();
            } else {
              this.$toast(data.data.msg);
            }
          }
        });
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.scenicParkDetail {
  .banner_container {
    position: relative;
    width: 100%;
    min-height: 177px;
    // background: gray;
    .video_ele {
      width: 100%;
      height: 177px;
      object-fit: fill;
    }
    .indicator_box {
      position: absolute;
      bottom: 20px;
      right: 20px;
      color: white;
      padding: 2px 8px;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 10px;
    }
  }

  .desc_container {
    padding: 10px 20px 30px 20px;
    padding-bottom: 0;
    border-bottom: 5px solid rgba(0, 0, 0, 0.05);
    .desc_box {
      display: flex;
      justify-content: space-between;
      .desc_left {
        padding-top: 20px;
      }
      .desc_right {
        .right_top {
          display: flex;
          .right_collect {
            display: flex;
            align-items: flex-start;
            div {
              font-size: 12px;
              color: #262626;
              margin-left: 2px;
            }
          }
          img {
            width: 24px;
            height: 24px;
            vertical-align: top;
            margin-left: 20px;
          }
        }
        .right_bottom {
          display: flex;
          .bottom_item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-left: 18px;
            margin-top: 10px;
            img {
              width: 32px;
              height: 32px;
              margin-bottom: 4px;
            }
            .item_text {
              font-size: 11px;
              color: rgba(0, 0, 0, 0.5);
            }
          }
        }
      }
    }
    .desc_title {
      font-size: 24px;
      color: #262626;
      font-weight: 700;
    }
    .desc_label_box {
      margin-top: 10px;
      .desc_label {
        padding: 2px 5px;
        background: rgba(97, 69, 247, 0.15);
        color: #6145f7;
        display: inline-block;
        margin-right: 5px;
      }
    }
    .desc_bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 30px 20px;
      .bottom_item {
        display: flex;
        .number {
          font-size: 36px;
          color: black;
          align-items: flex-end;
          display: flex;
        }
        .text {
          display: flex;
          color: #bfbfbf;
          font-size: 13px;
          margin-left: 4px;
          align-items: flex-end;
        }
      }
      .bottom_item_line {
        width: 1px;
        height: 26px;
        background: #d8d8d8;
      }
    }
  }
  .recommend_container {
    margin-top: 40px;
    padding-left: 20px;
    padding-right: 20px;
    .recommend_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 20px;
      margin-bottom: 20px;
    }

    .title_left {
      font-size: 20px;
      font-weight: 400;
    }
    .best_container {
      .best_item {
        display: flex;
        flex-direction: column;
        // margin-bottom: 25px;
        // margin-right: 12px;
        .item_right {
          //   margin-left: 18px;
          .title {
            font-size: 16px;
            color: #262626;
            font-weight: 700;
            margin-bottom: 8px;
          }
          .item_title {
            margin-bottom: 4px;
          }
          .distance {
            font-size: 11px;
            color: #787878;
          }
          .label_box {
            // display: flex;
            margin-bottom: 6px;
            .label {
              padding: 0px 4px;
              background: rgba(97, 69, 247, 0.15);
              border-radius: 2px;
              color: #6145f7;
              margin-right: 4px;
              display: inline-block;
            }
          }
        }
      }
    }
    .right_like {
      color: rgba(0, 0, 0, 0.5);
      font-size: 11px;
    }
    .tags_container {
      display: flex;
      flex-wrap: wrap;
      max-height: 20px;
      overflow: hidden;
      margin-bottom: 4px;
      .tags {
        margin-right: 3px;
        padding: 1px 3px;
        background: rgba(0, 0, 0, 0.05);
        color: #787878;
        font-size: 11px;
      }
    }
    .label_component {
      font-size: 11px;
      color: #2eba73;
      margin-top: 4px;
    }
    .strategy_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 20px;
      margin-bottom: 20px;
      .title_left {
        font-size: 20px;
        font-weight: 400;
      }
      .title_right {
        display: flex;
        align-items: center;
        span {
          margin-right: 10px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.5);
        }
      }
      .title_tag {
        display: flex;
        align-items: center;
        white-space: nowrap;
        width: 100%;
        overflow-x: auto;
        ::-webkit-scrollbar {
          width: 0px;
        }
        .tag_item {
          margin-right: 30px;
          font-size: 16px;
          color: #787878;
          padding-bottom: 5px;
          cursor: pointer;
          width: initial;
        }
        .tag_item_active {
          font-size: 20px;
          color: #000000;
          position: relative;
          .item_line {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 20px;
            height: 4px;
            background: #2ed07e;
            border-radius: 2px;
          }
        }
      }
    }
    .strategy_title {
      padding-right: 0;
    }
    .tab_box {
      margin-bottom: 20px;
    }
    .label {
      font-size: 11px;
      color: rgba(0, 0, 0, 0.25);
      margin-top: 4px;
      display: flex;
      .label_item {
        background: rgba(97, 69, 247, 0.15);
        color: #6e5adb;
        margin-right: 4px;
        padding: 3px 4px;
      }
    }
    .address {
      font-size: 11px;
      color: rgba(0, 0, 0, 0.25);
      margin-top: 4px;
    }
  }
  .intro_container {
    padding: 30px 20px;
    color: #262626;
    border-bottom: 5px solid rgba(0, 0, 0, 0.05);
    .intro_title {
      font-size: 20px;
      font-weight: 700;
    }
    .intro_innerText {
      font-size: 14px;
      color: #787878;
      margin-top: 10px;
      line-height: 20px;
      //   width: 200px;
    }
    .intro_innerText_hidden {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box; //将对象作为弹性伸缩盒子模型显示
      -webkit-line-clamp: 4; //控制显示几行文字
      -webkit-box-orient: vertical; //设置伸缩盒对象的子元素排列方式
    }
    .intro_fold {
      margin-top: 4px;
      font-size: 14px;
      color: #2eba73;
      display: flex;
      align-items: center;
      img {
        width: 11px;
        height: 7px;
        margin-left: 4px;
      }
    }
    .intro_map {
      width: 100%;
      height: 150px;
      margin-top: 20px;
    }
  }

  .pro_box {
    padding: 30px 20px;
    .pro_item_start {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      .item_text {
        display: flex;
        align-items: baseline;
        .text_title {
          font-size: 17px;
          font-weight: 700;
        }
        .text_desc {
          font-size: 12px;
          color: #bfbfbf;
          margin-left: 10px;
        }
      }
      img {
        width: 24px;
        height: 24px;
        margin-right: 14px;
      }
    }
    .pro_item {
      position: relative;
      padding-left: 12px;

      .item_item_top {
        position: relative;
        padding-left: 24px;
        padding-bottom: 25px;
        padding-top: 8px;
        border-left: 1px dashed #bfbfbf;
        .position_icon {
          position: absolute;
          top: 8px;
          left: 0;
          transform: translateX(-50%);
          img {
            width: 20px;
            height: 25px;
          }
        }
        .item_top_text {
          font-size: 13px;
          color: #bfbfbf;
        }
      }
      .item_bottom {
        position: relative;
        display: flex;
        justify-content: space-between;
        border-left: 1px dashed #bfbfbf;
        padding-left: 24px;
        padding-bottom: 10px;
        // align-items: center;
        .position_index {
          position: absolute;
          top: 0;
          left: 0;
          transform: translateX(-50%);
          width: 24px;
          height: 24px;
          background: #e5e5e5;
          font-size: 14px;
          line-height: 24px;
          text-align: center;
          border-radius: 50%;
          color: rgba(0, 0, 0, 0.5);
        }
        .item_bottom_img {
          display: flex;
          width: 70%;
          .item_bottom_middle {
            margin-left: 18px;
            .middle_title {
              font-size: 17px;
              color: #262626;
              font-weight: 700;
              margin-bottom: 6px;
            }
            .middle_distance {
              font-size: 12px;
              color: #787878;
              margin-bottom: 6px;
            }
            .middle_labels {
              div {
                display: inline-block;
              }
              .middle_label {
                padding: 0px 4px;
                background: rgba(97, 69, 247, 0.15);
                font-size: 11px;
                color: #6e5adb;
                margin-right: 4px;
              }
            }
          }
        }
        .item_bottom_right {
          display: flex;
          width: 30%;
          .right_item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            // margin-right: 20px;
            img {
              width: 31px;
              height: 31px;
            }
            div {
              font-size: 11px;
              margin-top: 4px;
              color: rgba(0, 0, 0, 0.5);
            }
          }
          .right_first {
            margin-right: 20px;
          }
        }
      }
    }
  }

  // 评论列表 start
  .comment-box {
    padding: 20px;
    border-top: 5px solid rgba(0, 0, 0, 0.05);
    border-bottom: 5px solid rgba(0, 0, 0, 0.05);
    /deep/ .van-cell {
      margin: 25px 0px;
      padding: 0px;
    }
    /deep/ .van-cell__title span {
      font-size: 20px;
      font-family: PingFangTC-Medium, PingFangTC;
      font-weight: 500;
      color: rgba(55, 56, 77, 1);
    }
    /deep/ .van-cell__value {
      font-size: 15px;
      font-family: PingFangSC-Light, PingFang SC;
      // font-weight: 300;
      color: #000;
    }
    /deep/ .van-cell:not(:last-child)::after {
      border: 0px;
    }
    /deep/ .van-icon {
      color: #37384d;
      font-size: 16px;
    }
    .comment-list {
      padding: 0px;
    }
    .list-no {
      text-align: left;
      // padding: 30px 0px 0px 0px;
      & > p {
        height: 14px;
        font-size: 15px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: rgba(153, 153, 153, 1);
        line-height: 14px;
      }
    }
    .btn {
      margin-top: 29px;
      width: 100%;
      opacity: 0.95;
      margin-bottom: 24px;
      /deep/ .van-image {
        margin-right: 4px;
        margin-top: -3px;
        img {
          border-radius: 3px;
        }
      }
      /deep/ .van-button {
        width: 100%;
        border: 0px;
        height: 40px;
      }
      /deep/ .van-button span {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        /deep/ .van-icon {
          color: #fff;
          margin-right: 7px;
        }
      }
      /deep/ .van-icon {
        color: #fff;
        margin-right: 7px;
      }
    }
  }
  // 评论列表 end
}
</style>
